export const availableFinancialYears = [
  '2021-22',
  '2022-23',
  '2023-24',
  '2024-25',
  '2025-26',
]
